import _ from 'lodash'


export const getOptions = ({ list, valueField, labelField }: any) => {
  const data: any = _.map(
    list,
    (option: any) => ({ value: _.property(valueField)(option), label: _.property(labelField)(option) })
  );
  return data
}
